import { FishingGuide } from '../../types';
import { doc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { safeWrite } from './coreService';

export const fetchGuides = async (firestore: any): Promise<FishingGuide[]> => {
  const snap = await getDocs(collection(firestore, 'guides'));
  return snap.docs.map(d => d.data() as FishingGuide);
};

export const addGuide = async (firestore: any, guide: FishingGuide) => {
  await safeWrite(doc(firestore, 'guides', guide.id), guide);
};

export const updateGuide = async (firestore: any, guide: FishingGuide) => {
  await safeWrite(doc(firestore, 'guides', guide.id), guide);
};

export const removeGuide = async (firestore: any, id: string) => {
  await deleteDoc(doc(firestore, 'guides', id));
};
